module.exports = __webpack_public_path__ + "static/media/clock.08d6eb1d.svg";